import type { Move, ResolvedMove } from '@shared/protocol/messages';

export const MOVES: readonly Move[] = ['rock', 'paper', 'scissors'];

const BEATS: Record<Move, Move> = {
  rock: 'scissors',
  scissors: 'paper',
  paper: 'rock',
};

export function isMove(v: unknown): v is Move {
  return v === 'rock' || v === 'paper' || v === 'scissors';
}

/** The move that beats `m`. */
export function counterOf(m: Move): Move {
  return m === 'rock' ? 'paper' : m === 'paper' ? 'scissors' : 'rock';
}

/**
 * Compare two moves. Returns 0 if `a` wins, 1 if `b` wins, -1 on a tie.
 * A timeout loses to any real move; two timeouts tie.
 */
export function judge(a: ResolvedMove, b: ResolvedMove): -1 | 0 | 1 {
  if (a === b) return -1;
  if (a === 'timeout') return 1;
  if (b === 'timeout') return 0;
  return BEATS[a] === b ? 0 : 1;
}
